module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app login",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper background-1-60",
    staticStyle: {
      "background": "#64ccdc"
    }
  }, [(!_vm.getIsLoggedIn) ? _c('Authorization-header') : _vm._e(), _vm._v(" "), (_vm.getIsLoggedIn) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "center template-404"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-404-label"
  }, [_c('h1', {
    staticClass: "color-2-100"
  }, [_vm._v("This error is usually triggered by mistyping the page URL, but may also appear when a page was moved or the user doesn't have sufficient permissions to see it.")]), _vm._v(" "), (_vm.getIsLoggedIn) ? _c('p', {
    staticClass: "color-2-100"
  }, [_vm._v("Use the search box above or go to the homepage and start browsing our content from there. If you believe you found a bug in our system or you need any help, please email us at "), _c('a', {
    attrs: {
      "href": "mailto:support.team@clearassured.co.uk"
    }
  }, [_vm._v("support.team@clearassured.co.uk")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "go-to-homepage color-2-100 background-1-30",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Go to Homepage")])])])]), _vm._v(" "), _c('div', {
    staticClass: "push"
  })], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-title-404"
  }, [_c('span', {
    staticClass: "group-404"
  }, [_c('span', [_vm._v("4")]), _c('span'), _c('span', [_vm._v("4")])]), _vm._v("Page not found")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e858e30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Error.vue
// module id = 975
// module chunks = 0